export default "__VITE_ASSET__OvJ2eouW__"